import type { UseFormReturn } from 'react-hook-form';

import dayjs from 'dayjs';

import type { JobPost } from '~/api/jobPosts/types';

import { CommandMenuItem } from '~/providers/CommandMenuProvider/CommandMenuItem';

import type { JobPostForm } from './types';

import { jobPosts } from '../../../../tests/mocks/jobPosts.fake';

type Props = {
  form: UseFormReturn<JobPostForm>;
};

type NonEmptyArray<T> = [T, ...Array<T>];

const getRandom = <T,>(array: NonEmptyArray<T>): T => array[Math.floor(Math.random() * array.length)];

export const JobPostFormCommandMenuItems = ({ form: { setValue } }: Props) => (
  <CommandMenuItem
    group="Jobs"
    label="Fill input fields"
    onClick={() => {
      const randomJobPost = getRandom<JobPost>(jobPosts);
      const options = { shouldDirty: true, shouldTouch: true };

      setValue('title', randomJobPost.title, options);
      setValue('description', randomJobPost.description, options);
      setValue('activityIds', randomJobPost.activityIds, options);
      setValue('price', randomJobPost.price, options);
      setValue('priceUnit', randomJobPost.priceType === 'Tbd' ? 'Fixed' : randomJobPost.priceType, options);
      setValue('region', randomJobPost.region, options);
      setValue('locationType', randomJobPost.locationType, options);
      setValue('startsAt', randomJobPost.startsAt !== null ? dayjs(randomJobPost.startsAt).toDate() : null, options);
      setValue('endsAt', randomJobPost.endsAt !== null ? dayjs(randomJobPost.endsAt).toDate() : null, options);
      setValue('closesAt', randomJobPost.closesAt !== null ? dayjs(randomJobPost.closesAt).toDate() : null, options);
      setValue('experienceLevel', randomJobPost.experienceLevel, options);
    }}
  />
);
